import { render, staticRenderFns } from "./EnpukuPage.vue?vue&type=template&id=bab65d80&scoped=true&"
import script from "./EnpukuPage.vue?vue&type=script&lang=js&"
export * from "./EnpukuPage.vue?vue&type=script&lang=js&"
import style0 from "./EnpukuPage.vue?vue&type=style&index=0&id=bab65d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab65d80",
  null
  
)

export default component.exports